<template>
  <div>
    <search-area tabName="回收订单列表" @search="search(1)">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="回收状态" prop="status" :label-width="105">
          <Select
            v-model="searchParam.status"
            style="width: 160px"
            @on-change="search(1)"
            clearable
          >
            <Option
              v-for="item in statusList"
              :value="item.code"
              :key="item.code"
              >{{ item.value }}</Option
            >
          </Select>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="recycleList"
      :total="total"
      @search="search"
      :pageNum="searchParam.page"
      :pageSize="searchParam.pageSize"
    ></table-area>

    <!-- 更新状态弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showUpdateDialog"
      width="500px"
    >
      <el-form
        :model="updateForm"
        ref="updateForm"
        :rules="currentRules"
        label-width="120px"
      >
        <el-form-item
          v-if="currentStatus === 'pending'"
          label="预估回收价格"
          prop="estimatedPrice"
        >
          <el-input
            v-model="updateForm.estimatedPrice"
            placeholder="请输入预估回收价格"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="currentStatus === 'assessed'"
          label="实际价格"
          prop="actualPrice"
        >
          <el-input
            v-model="updateForm.actualPrice"
            placeholder="请输入实际价格"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="
            currentStatus === 'assessed' && currentRow && currentRow.type == 1
          "
          label="实际重量"
          prop="realWeight"
        >
          <el-input
            v-model="updateForm.realWeight"
            placeholder="请输入实际重量"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="currentStatus === 'pending'"
          label="回收快递单号"
          prop="trackingNum"
        >
          <el-input
            v-model="updateForm.trackingNum"
            placeholder="请输入回收快递单号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateDialog">取 消</el-button>
        <el-button type="primary" @click="handleUpdateRecycle">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 退货弹窗 -->
    <el-dialog title="退货" :visible.sync="showReturnDialog" width="500px">
      <el-form
        :model="returnForm"
        ref="returnForm"
        :rules="returnRules"
        label-width="120px"
      >
        <el-form-item label="退货订单号" prop="trackingReturnNum">
          <el-input
            v-model="returnForm.trackingReturnNum"
            placeholder="请输入退货订单号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showReturnDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleReturn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import columns from "./recycle-column";
export default {
  data() {
    return {
      columns: columns(this),
      // 列表数据总数
      total: 0,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        status: "", // 回收状态
        page: 1,
        pageSize: 10,
      },
      recycleList: [],
      currentRow: null,
      currentStatus: "", // 当前操作的状态
      showUpdateDialog: false,
      showReturnDialog: false,
      updateForm: {
        estimatedPrice: "",
        actualPrice: "",
        realWeight: "",
        trackingNum: "",
      },
      updateRules: {
        estimatedPrice: [
          { required: true, message: "请输入预估回收价格", trigger: "blur" },
        ],
        actualPrice: [
          { required: true, message: "请输入实际价格", trigger: "blur" },
        ],
        realWeight: [
          { required: true, message: "请输入实际重量", trigger: "blur" },
        ],
        trackingNum: [
          { required: true, message: "请输入回收快递单号", trigger: "blur" },
        ],
      },
      returnForm: {
        trackingReturnNum: "",
      },
      returnRules: {
        trackingReturnNum: [
          { required: true, message: "请输入退货订单号", trigger: "blur" },
        ],
      },
      statusList: [
        { code: "pending", value: "已预约" },
        { code: "assessed", value: "回收中" },
        { code: "completed", value: "已完成" },
        { code: "applyreturn", value: "申请退回" },
        { code: "rejected", value: "已退回" },
      ],
      typeList: [
        { code: 0, value: "手机" },
        { code: 1, value: "衣物" },
      ],
    };
  },
  computed: {
    dialogTitle() {
      const titleMap = {
        pending: "填写预估价格",
        assessed: "填写实际价格",
      };
      return titleMap[this.currentStatus] || "更新回收订单";
    },
    currentRules() {
      const rules = {};
      if (this.currentStatus === "pending") {
        rules.estimatedPrice = this.updateRules.estimatedPrice;
        rules.trackingNum = this.updateRules.trackingNum;
      } else if (this.currentStatus === "assessed") {
        rules.actualPrice = this.updateRules.actualPrice;
        // 如果是衣物类型，需要验证实际重量
        if (this.currentRow && this.currentRow.type == 1) {
          rules.realWeight = this.updateRules.realWeight;
        }
      }
      return rules;
    },
  },
  created() {
    this.getRecycleList();
  },
  methods: {
    // 执行搜索
    search(val) {
      this.searchParam.page = val;
      this.getRecycleList();
    },
    async getRecycleList() {
      // 过滤掉空值参数
      const params = {};
      Object.keys(this.searchParam).forEach((key) => {
        if (
          this.searchParam[key] !== "" &&
          this.searchParam[key] !== null &&
          this.searchParam[key] !== undefined
        ) {
          params[key] = this.searchParam[key];
        }
      });

      let res = await this.$post("/recycle/recycleList", params);
      console.log(res);
      this.recycleList = res || [];
      // this.total = res.total || 0;
    },
    closeUpdateDialog() {
      this.showUpdateDialog = false;
      this.currentStatus = "";
      this.updateForm = {
        estimatedPrice: "",
        actualPrice: "",
        realWeight: "",
        trackingNum: "",
      };
      if (this.$refs.updateForm) {
        this.$refs.updateForm.resetFields();
      }
    },
    // 更新回收订单状态
    handleUpdateRecycle() {
      this.$refs.updateForm.validate(async (valid) => {
        if (valid) {
          try {
            const payload = { id: this.currentRow.id };

            // 根据状态构建不同的请求参数
            if (this.currentStatus === "pending") {
              payload.estimatedPrice = this.updateForm.estimatedPrice;
              payload.trackingNum = this.updateForm.trackingNum;
              payload.status = "assessed"; // 填写预估价格后，状态变为回收中
            } else if (this.currentStatus === "assessed") {
              payload.actualPrice = this.updateForm.actualPrice;
              // 如果是衣物类型，需要传递实际重量
              if (this.currentRow && this.currentRow.type == 1) {
                payload.realWeight = this.updateForm.realWeight;
                payload.status = "completed"; // 衣物回收填写实际重量和实际价格后，状态变为已完成
              }
              // 非衣物类型，填写实际价格后，状态不变
            }

            const res = await this.$http.post(
              "/recycle/updateRecycle",
              payload,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            if (res.status === 200) {
              this.$message.success("操作成功");
              this.closeUpdateDialog();
              this.getRecycleList();
            } else {
              this.$message.error(res.data.message || "操作失败");
            }
          } catch (error) {
            this.$message.error("操作失败");
          }
        }
      });
    },
    // 处理退货
    handleReturn() {
      this.$refs.returnForm.validate(async (valid) => {
        if (valid) {
          try {
            const res = await this.$http.post(
              "/recycle/updateRecycle",
              {
                id: this.currentRow.id,
                status: "rejected",
                trackingReturnNum: this.returnForm.trackingReturnNum,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            if (res.status === 200) {
              this.$message.success("退货成功");
              this.showReturnDialog = false;
              this.getRecycleList();
              this.$refs.returnForm.resetFields();
            } else {
              this.$message.error(res.data.message || "退货失败");
            }
          } catch (error) {
            this.$message.error("退货失败");
          }
        }
      });
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped>
@import './../../styl/variables.styl'
@import './../../styl/common.styl'
</style>
